import React, { FC, useState } from "react";
import { Modal} from "antd";
import _ from "lodash";

import 'antd/dist/antd.css';
import AnswerModel from './AnswerModal'
import AdminQuestionaireModal from './AdminSurveyModal'

const AddSurveyModal: FC<{ data: any; moveNext:any, moveBack:any, onCreate:any,onCancel: any; isEditQuestion: boolean, type: string, isEditMode: boolean, count: number, totalQuestions: number }> = ({ data, moveNext, moveBack, onCreate, isEditQuestion, onCancel, type, isEditMode, count, totalQuestions }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {  
    setIsModalVisible(false);
    onCancel();
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const onAddQuestionaire = (item)=>{
     onCreate(item);
     setIsModalVisible(false);
  }

  return (
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >

      { !isEditMode  ?
       <AdminQuestionaireModal 
       handleCancel={handleCancel} 
       onCreate={onAddQuestionaire}
       data={data} 
       isEditQuestion={isEditQuestion}
       /> :
       <AnswerModel 
       data={data} 
       count={count}
       totalQuestions={totalQuestions}
       moveNext={(answer)=> moveNext(answer)} 
       moveBack={moveBack} 
       onClose={handleCancel}
       
       />
    }
    </Modal>
  );
};

export default AddSurveyModal;
